import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
var ExternalAuthService = /** @class */ (function () {
    function ExternalAuthService() {
        this.apiBase = environment.apiBase;
        this.config = environment.externalAuth;
    }
    ExternalAuthService.prototype.getEnabledProviders = function () {
        var _this = this;
        if (!this.config || !this.config.providers) {
            return [];
        }
        return Object.entries(this.config.providers)
            .filter(function (_a) {
            var providerConfig = _a[1];
            return providerConfig && providerConfig.enabled;
        })
            .map(function (_a) {
            var id = _a[0], providerConfig = _a[1];
            return ({
                id: id,
                label: providerConfig.label || _this.toTitleCase(id)
            });
        });
    };
    ExternalAuthService.prototype.getSpaCallbackUrl = function () {
        var origin = typeof window !== 'undefined' && window.location
            ? window.location.origin
            : '';
        var path = this.getSpaCallbackPath();
        if (!origin) {
            return path;
        }
        return this.joinUrl(origin, path);
    };
    ExternalAuthService.prototype.buildChallengeUrl = function (providerId, returnUrl) {
        if (!providerId) {
            throw new Error('Provider is required to build challenge URL.');
        }
        var base = this.joinUrl(this.apiBase, this.config.challengePath);
        var query = new URLSearchParams();
        query.set('provider', providerId);
        if (returnUrl) {
            query.set('returnUrl', returnUrl);
        }
        return base + "?" + query.toString();
    };
    ExternalAuthService.prototype.beginExternalLogin = function (providerId, returnUrl) {
        var challengeUrl = this.buildChallengeUrl(providerId, returnUrl);
        window.location.href = challengeUrl;
    };
    ExternalAuthService.prototype.parseCallback = function (paramMap) {
        var allParams = this.getAllParams(paramMap);
        var status = (paramMap.get('status') || '').toLowerCase();
        if (status === 'success') {
            return {
                status: status,
                token: paramMap.get('token') || '',
                provider: paramMap.get('provider') || undefined,
                rawParams: allParams
            };
        }
        return {
            status: 'error',
            code: paramMap.get('code') || undefined,
            message: paramMap.get('message') || undefined,
            provider: paramMap.get('provider') || undefined,
            rawParams: allParams
        };
    };
    ExternalAuthService.prototype.buildSessionFromCallback = function (callback) {
        if (!callback.token) {
            return null;
        }
        var payload = this.decodeJwtPayload(callback.token);
        var roleIdRaw = callback.rawParams['roleId'];
        var clientId = callback.rawParams['clientId'];
        var clientNameRaw = callback.rawParams['clientName'];
        var clientName = clientNameRaw && clientNameRaw.trim().length > 0
            ? clientNameRaw
            : 'CompPBM';
        var firstName = callback.rawParams['firstName'] || this.extractFirstNameFromPayload(payload) || 'User';
        var userId = callback.rawParams['userId'] || this.extractUserIdFromPayload(payload);
        var pwdVerifiedRaw = callback.rawParams['isPwdVerified'] != null
            ? callback.rawParams['isPwdVerified']
            : 'true';
        var email = callback.rawParams['email'] || this.extractEmailFromPayload(payload);
        var roleId = roleIdRaw || '3';
        if (!userId) {
            return null;
        }
        return {
            token: callback.token,
            roleId: roleId,
            clientId: this.normalizeClientId(clientId),
            clientName: clientName,
            firstName: firstName,
            userId: userId,
            isPwdVerified: this.parseBoolean(pwdVerifiedRaw),
            email: email || undefined,
            provider: callback.provider
        };
    };
    ExternalAuthService.prototype.getCallbackPath = function () {
        return this.config && this.config.callbackPath
            ? this.config.callbackPath
            : 'api/ExternalAuth/ExternalLoginCallback';
    };
    ExternalAuthService.prototype.extractEmailFromToken = function (token) {
        try {
            var payload = this.decodeJwtPayload(token);
            return this.extractEmailFromPayload(payload);
        }
        catch (_a) {
            return null;
        }
    };
    ExternalAuthService.prototype.decodeJwtPayload = function (token) {
        if (!token) {
            return null;
        }
        var parts = token.split('.');
        if (parts.length < 2) {
            return null;
        }
        try {
            var payload = parts[1];
            var normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
            var padded = this.padBase64(normalized);
            var decoded = window.atob(padded);
            return JSON.parse(decoded);
        }
        catch (_a) {
            return null;
        }
    };
    ExternalAuthService.prototype.extractEmailFromPayload = function (payload) {
        if (!payload) {
            return null;
        }
        return payload.sub || payload.email || null;
    };
    ExternalAuthService.prototype.extractFirstNameFromPayload = function (payload) {
        if (!payload) {
            return null;
        }
        var userDataClaim = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
        if (typeof userDataClaim === 'string' && userDataClaim.trim().length > 0) {
            return userDataClaim.trim().split(' ')[0];
        }
        if (typeof payload.given_name === 'string') {
            return payload.given_name;
        }
        return null;
    };
    ExternalAuthService.prototype.extractUserIdFromPayload = function (payload) {
        if (!payload) {
            return null;
        }
        return (payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ||
            payload['http://schemas.microsoft.com/identity/claims/objectidentifier'] ||
            payload.sub ||
            null);
    };
    ExternalAuthService.prototype.padBase64 = function (value) {
        var padding = value.length % 4;
        if (padding === 2) {
            return value + '==';
        }
        if (padding === 3) {
            return value + '=';
        }
        if (padding !== 0) {
            return value + '==';
        }
        return value;
    };
    ExternalAuthService.prototype.parseBoolean = function (value) {
        return value === 'true' || value === '1';
    };
    ExternalAuthService.prototype.normalizeClientId = function (value) {
        if (value == null) {
            return null;
        }
        var parsed = Number(value);
        return Number.isNaN(parsed) ? value : parsed;
    };
    ExternalAuthService.prototype.joinUrl = function (base, path) {
        if (!path) {
            return base;
        }
        if (base.endsWith('/') && path.startsWith('/')) {
            return base + path.substr(1);
        }
        if (!base.endsWith('/') && !path.startsWith('/')) {
            return base + "/" + path;
        }
        return base + path;
    };
    ExternalAuthService.prototype.getSpaCallbackPath = function () {
        var rawPath = this.config &&
            this.config.spaCallbackPath;
        var normalized = typeof rawPath === 'string' ? rawPath.trim() : '';
        if (!normalized) {
            return '/auth/sso-callback';
        }
        return normalized.startsWith('/')
            ? normalized
            : "/" + normalized;
    };
    ExternalAuthService.prototype.toTitleCase = function (value) {
        if (!value) {
            return value;
        }
        return value
            .replace(/([A-Z])/g, ' $1')
            .replace(/[-_]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/^./, function (char) { return char.toUpperCase(); });
    };
    ExternalAuthService.prototype.getAllParams = function (paramMap) {
        var params = {};
        paramMap.keys.forEach(function (key) {
            params[key] = paramMap.get(key);
        });
        return params;
    };
    ExternalAuthService.ngInjectableDef = i0.defineInjectable({ factory: function ExternalAuthService_Factory() { return new ExternalAuthService(); }, token: ExternalAuthService, providedIn: "root" });
    return ExternalAuthService;
}());
export { ExternalAuthService };
